import React from "react";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const Signup = () => {
  const paperStyle = { padding: 20, width: 358, margin: "0 auto" };
  const headerStyle = { margin: 0 };
  const avatarStyle = { backgroundColor: "#f5f109" };
  const marginTop = { marginTop: 5 };

  return (
    <Grid>
      <Paper elevation={20} style={paperStyle}>
        <Grid align="center">
          <Avatar style={avatarStyle}>
            <AddCircleOutlineIcon />
          </Avatar>
          <h2 style={headerStyle}>Registrer</h2>
          <Typography variant="caption" gutterBottom>
            Fyll ut dette skjemaet for å opprette en konto!
          </Typography>
        </Grid>
        <form>
          <TextField
            variant="standard"
            fullWidth
            label="Navn"
            placeholder="Skriv ditt navn her"
          />
          <TextField
            variant="standard"
            fullWidth
            label="E-post"
            placeholder="Skriv e-post her"
          />

          <TextField variant="standard" fullWidth label="Passord" />
          <TextField variant="standard" fullWidth label="Bekreft passord" />

          <FormControlLabel
            control={<Checkbox defaultChecked color="success" />}
            label="Jeg godtar vilkårene og betingelsene."
          />
          <Button type="submit" variant="contained" color="primary">
            Registrer
          </Button>
        </form>
      </Paper>
    </Grid>
  );
};

export default Signup;
